export default __webpack_public_path__ + "static/media/image06.2e25df49.jpg";